import React from 'react';
import { images, tomos } from '../data/content';
export function TomosSection() {
  return <section aria-labelledby="tomos" className="bg-ink-900" data-id="element-182" data-mp="1kcbu5tdu2ppo">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:py-20" style={{
      paddingTop: "20px",
      paddingBottom: "25px"
    }} data-id="element-183" data-mp="1kaqzm3rir6rt">
        <p className="text-center text-sm font-bold uppercase tracking-[0.25em] text-ball-400" data-id="element-184" data-mp="1u2na6easkpcx">
          PADEL PRO-PACK™ 
        </p>
        <h2 id="tomos" className="mx-auto mt-4 max-w-3xl text-center font-display text-3xl uppercase leading-tight text-white sm:text-5xl" data-id="element-185" data-mp="xdfon6a6ag90">
          El sistema completo en 12 Tomos Maestros
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-center text-base leading-relaxed text-slate-300 sm:text-lg" data-id="element-186" data-mp="16c124n0sf52x">
          Más de 100 páginas de metodología pura. Todo lo que necesitas para enseñar, gestionar y
          escalar tu academia.
        </p>

        <div className="mt-10 overflow-hidden rounded-3xl border border-ink-600" data-id="element-187" data-mp="2hulrpg0u3gyi">
          <img src={images.tomos} alt="Los 12 tomos digitales del Padel Pro-Pack desplegados en abanico" className="h-52 w-full object-cover sm:h-72" data-id="element-188" data-mp="2mtf4f68ar3xm" />
        </div>

        <h3 className="mt-14 text-center font-display text-xl uppercase text-white sm:text-2xl" data-id="element-189" data-mp="2mnyfwckgtc6f">
          Los 12 tomos de oro
        </h3>

        <ol className="mt-6 grid gap-4 md:grid-cols-2" data-id="element-190" data-mp="2hpddq7lnkifc">
          {tomos.map(tomo => <li key={tomo.id} className="flex gap-4 rounded-2xl border border-ink-600 bg-ink-800 p-5 transition-colors duration-150 ease-out hover:border-court-500/60" data-id="element-191" data-mp="2cnxw6pioou1p">
              <span className="mt-0.5 shrink-0 rounded-lg bg-court-700 px-2.5 py-1 font-display text-xs text-court-50" data-id="element-192" data-mp="22xlauv31owui">
                {tomo.id}
              </span>
              <div data-id="element-193" data-mp="1txy4rvzdf2v4">
                <p className="font-semibold leading-snug text-white" data-id="element-194" data-mp="1tyr62hfk905v">{tomo.title}</p>
                <p className="mt-1.5 text-sm leading-relaxed text-slate-400" data-id="element-195" data-mp="1oyllfl7pkdxa">{tomo.description}</p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}